import { GOLDEN_TOWER, BLACK_HOLE } from 'utils/constants';

const ChronoField = ({ unlocked, showAll, currentCount }) => (
  <div className='weapon'>
    {!showAll && <div className='title'>You should pick Chrono Field</div>}
    {showAll && <div className='title'>Chrono Field</div>}
    {!showAll && unlocked[GOLDEN_TOWER] && unlocked[BLACK_HOLE] && (
      <div className='info'>
        Do not pick this until you sync your Black Hole and Golden Tower.
      </div>
    )}
    {(showAll || !unlocked[BLACK_HOLE]) && (
      <div className='info'>
        Keep looking for Black Hole before building this.
      </div>
    )}
  </div>
);

export default ChronoField;
